export function getInitialTelemetry() {
    const INITIAL_TELEMETRY = {
        "10-rain-intensity": 0,
        "30-rain-intensity": 0,
        "abs": 0,
        "active-cars": 0,
        "best-time": "--:--:---",
        "brake": 0,
        "brake-FL:temp": 0,
        "brake-FL:wear": 0,
        "brake-FR:temp": 0,
        "brake-FR:wear": 0,
        "brake-RL:temp": 0,
        "brake-RL:wear": 0,
        "brake-RR:temp": 0,
        "brake-RR:wear": 0,
        "car-damage:centre": 0,
        "car-damage:front": 0,
        "car-damage:left": 0,
        "car-damage:rear": 0,
        "car-damage:right": 0,
        "car-name": "None",
        "clutch": 0,
        "completed-laps": 0,
        "current-rain-intensity": 0,
        "current-time": "--:--:---",
        "delta-lap-time": "--:--:---",
        "distance-travelled": 0,
        "estimated-lap": "--:--:---",
        "flag": 0,
        "fuel": 0,
        "fuel-estimated-laps": 0,
        "fuel-x-lap": 0,
        "gap-ahead": 0,
        "gap-behind": 0,
        "gas": 0,
        "gear": "N",
        "in-pit": 0,
        "in-pitlane": 0,
        "is-chequered-flag": 0,
        "is-delta-positive": "-",
        "is-green-flag": 0,
        "is-online": 0,
        "is-red-flag": 0,
        "is-valid-lap": 1,
        "is-white-flag": 0,
        "last-time": "--:--:---",
        "max-fuel": 0,
        "max-rpm": 0,
        "penalty-time": 0,
        "player-name": "",
        "player-nickname": "",
        "player-surname": "",
        "position": 0,
        "road-data:air-temp": 0,
        "road-data:road-temp": 0,
        "rpm": 0,
        "session-status": 0,
        "session-type": 0,
        "speed": 0,
        "steer": 0,
        "tc": 0,
        "tc-cut": 0,
        "time-left": 0,
        "track": "None",
        "track-grip-status": 0,
        "tyre-FL:pressure": 0,
        "tyre-FL:temp": 0,
        "tyre-FL:wear": 0,
        "tyre-FR:pressure": 0,
        "tyre-FR:temp": 0,
        "tyre-FR:wear": 0,
        "tyre-RL:pressure": 0,
        "tyre-RL:temp": 0,
        "tyre-RL:wear": 0,
        "tyre-RR:pressure": 0,
        "tyre-RR:temp": 0,
        "tyre-RR:wear": 0,
        "tyre-compound": "Dry",
        "used-fuel": 0,
        "water-temp": 0,
        "brake-bias": 0,
        "fuel-needed": 0,
        "fuel-safe": 0,
        "raw-laps": 0,
        "fuel-delta": 0,
        "is-engine-running": 0,
        "ignition": 0,
        "wiper-stage": 0,
        "lights-stage": 0,
        "flashing-lights": 0,
        "current-tyre-set": 0,
    }

    return INITIAL_TELEMETRY
}

export function getInitialLeaderboard() {
    const INITIAL_LEADERBOARD = [
        {
            "car-id": 0,
            "position": 0,
            "name": "",
            "car-number": "0",
            "gap": "-",
            "best-lap": "--:--:---",
            "last-lap": "--:--:---",
            "status": "track",
            "pits": 0,
            "laps": 0,
            "lap-last-pit": 0,
            "spline": "0"
        }
    ]

    return INITIAL_LEADERBOARD
}